var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventHostPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "30px",
    viewBox: "0 0 52 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EventHostPaid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "61.8674045%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED66FE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C693FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-Event-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-348.000000, -220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(222.000000, 213.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,37 L128,37 C126.895431,37 126,36.1045695 126,35 L126,9 C126,7.8954305 126.895431,7 128,7 L176,7 C177.104569,7 178,7.8954305 178,9 L178,35 C178,36.1045695 177.104569,37 176,37 Z M174,17 C170.686292,17 168,14.3137085 168,11 L136,11 C136,14.3137085 133.313708,17 130,17 L130,28 C132.926034,28.0015642 135.42371,30.1146575 135.91,33 L168.09,33 C168.576213,30.114614 171.073936,28.0014818 174,28 L174,17 Z M152,30 C148.3437,30 146,26.875 146,22 C146,17.125 148.3437,14 152,14 C155.6563,14 158,17.125 158,22 C158,26.875 155.6563,29.9999 152,29.9999 L152,30 Z",
    id: "EventHostPaid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHostPaid);
export default __webpack_public_path__ + "static/media/EventHostPaid.6a6e2e4e1200717befe624f9858766f3.svg";
export { ForwardRef as ReactComponent };